const getTask = (title, size = 'l') => ({
  title,
  size,
  ready: false,
  current: false,
  values: [false, false, false],
})

const getSite = title => ({
  title,
  ready: false,
  saved: false,
  password: 'skobec12345678',
})

const data = () => ({
  tasks: [
    getTask('Проверь, могут ли быть доступны твои данные посторонним людям.'),
    getTask('Срочно поменяй пароль, если он стал общедоступным.'),
    getTask('Пароль должен быть надежным:'),
    getTask('Состоять минимум из 12 символов;', 's'),
    getTask('Содержать заглавные и строчные буквы, цифры, специальные символы;', 's'),
    getTask('Не включать общедоступную информацию (например: имя или дату рождения...);', 's'),
    getTask('Создавай разные пароли для разных сайтов;', 's'),
    getTask('Используй двухфакторную авторизацию, где это возможно.', 's'),
    getTask('Сохрани пароли в менеджере паролей, чтобы не забыть.'),
    getTask('Меняй пароль регулярно (поставь напоминание в календаре).'),
  ],
  sites: [
    getSite('abc***games.ru'),
    getSite('tuti****.ru'),
    getSite('poch***at.com'),
  ],
})

export default data()
